<template>
    <module-card :nextDisabled="nextDisabled">
        <div class="comic-container">
            <v-carousel :continuous="false" hide-delimiters @change="change" height="320">
                <v-carousel-item v-for="(comic, id) in comics" :key="id" :src="comic.img" contain></v-carousel-item>
            </v-carousel>
        </div>
    </module-card>
</template>

<script>
    import { every } from 'lodash';

    export default {
        data() {
            return {
                comics: [
                    {
                        id: 1,
                        img: require('@/assets/PeepInLove/Comic/Comic04-1.png'),
                        visited: false
                    },
                    {
                        id: 2,
                        img: require('@/assets/PeepInLove/Comic/Comic04-2.png'),
                        visited: false
                    },
                    {
                        id: 3,
                        img: require('@/assets/PeepInLove/Comic/Comic04-3.png'),
                        visited: false
                    },
                    {
                        id: 4,
                        img: require('@/assets/PeepInLove/Comic/Comic04-4.png'),
                        visited: false
                    },
                    {
                        id: 5,
                        img: require('@/assets/PeepInLove/Comic/Comic04-5.png'),
                        visited: false
                    }
                ]
            };
        },
        methods: {
            change(i) {
                this.comics[i].visited = true;
            },
            nextDisabled() {
                return !every(this.comics, (c) => {
                    return c.visited;
                });
            }
        }
    };
</script>

<style scoped>
    .comic-container {
        position: relative;
        width: 100%;
    }
</style>
